import {
  bootstrap,
  cancelPayment,
  initializeHeapAgent,
  trackCancelPayment,
} from 'actions';
import { LayoutRouter } from 'components/LayoutRouter/LayoutRouter';
import { MaintenancePage } from 'components/MaintenancePage/MaintenancePage';
import { Spinner } from 'components/ui/Spinner';
import { NOOP } from 'constants/actions';
import { MAINTENANCE_MODE } from 'constants/index';
import { ModalProvider } from 'contexts/Modal';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FeatureFlag } from '../FeatureFlag/FeatureFlag';

const CheckoutComponent = ({
  bootstrap,
  cancelPayment = NOOP,
  onClose = NOOP,
  trackCancelPayment = NOOP,
  initializeHeapAgent = NOOP,
  ...rest
}) => {
  const [isFetching, setIsFetching] = useState(true);

  // biome-ignore lint/correctness/useExhaustiveDependencies: we want it to run only when the component is mounted
  useEffect(() => {
    async function setup() {
      await bootstrap();
      initializeHeapAgent();
      setIsFetching(false);
    }

    setup();
  }, [bootstrap]);

  async function handleOnCancelAndClose() {
    await Promise.all([cancelPayment(), trackCancelPayment()]);
    onClose();
  }

  function handleOnRestart() {
    cancelPayment();
  }

  function handleOnClose() {
    onClose();
  }

  if (isFetching) {
    return <Spinner className="h-[100vh]" />;
  }

  return (
    <FeatureFlag feature={MAINTENANCE_MODE}>
      {enabled =>
        enabled ? (
          <ModalProvider
            onClose={handleOnClose}
            confirmBeforeClosing={false}
            cancelPaymentBeforeClosing={false}
          >
            <MaintenancePage />
          </ModalProvider>
        ) : (
          <ModalProvider
            onClose={handleOnClose}
            onCancelAndClose={handleOnCancelAndClose}
          >
            <LayoutRouter onRestart={handleOnRestart} {...rest} />
          </ModalProvider>
        )
      }
    </FeatureFlag>
  );
};

CheckoutComponent.propTypes = {
  bootstrap: PropTypes.func.isRequired,
  cancelPayment: PropTypes.func,
  initializeHeapAgent: PropTypes.func,
  onClose: PropTypes.func,
  trackCancelPayment: PropTypes.func,
};

const mapDispatchToProps = {
  bootstrap,
  cancelPayment,
  trackCancelPayment,
  initializeHeapAgent,
};

export const Checkout = connect(null, mapDispatchToProps)(CheckoutComponent);
